import { getConnectorVersion } from './connectorVersion';
import { isLocalLibraryCommandError } from '../services/localLibraryIpcGate';

export const PER_ALBUM_UPDATE_HINT = 'Update Maestro to use this';

let connectorVersionLogged = false;

/** Log installed Connector version once per session when per-album actions run. */
export function logConnectorVersionOnce(): void {
  if (connectorVersionLogged || typeof window === 'undefined') return;
  connectorVersionLogged = true;
  const version = getConnectorVersion();
  console.info('[library] connector version', version || '(unknown)');
}

export function isPerAlbumCommandUnavailable(err: unknown): boolean {
  return isLocalLibraryCommandError(err);
}

export function getPerAlbumActionErrorHint(err: unknown): string | null {
  if (!isPerAlbumCommandUnavailable(err)) return null;
  return PER_ALBUM_UPDATE_HINT;
}

export function buildRemoveAlbumConfirmMessage(title?: string | null): string {
  const name = (title || 'this album').trim() || 'this album';
  return (
    `Remove "${name}" from your library?\n\n`
    + 'Your music files on disk will not be deleted. '
    + 'This album may be added again the next time Maestro scans that folder.'
  );
}

export function albumManageKey(album: { album_key?: string; id?: string } | null | undefined): string {
  return String(album?.album_key || album?.id || '').trim();
}
